<template>
  <div class="toggle-tab">
    <div class="tab-item" :class="currentIndex === 1 ? 'current' : ''" @click.stop="toggle(1)">
      <span class="tab-link">按险种显示</span>
    </div>
    <div class="tab-item" :class="currentIndex === 0 ? 'current' : ''" @click.stop="toggle(0)">
      <span class="tab-link">按责任显示</span>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        currentIndex: 1
      }
    },
    methods: {
      toggle(showType) {
        if (this.currentIndex === showType) return
        this.currentIndex = showType;
        this.$emit('toggle', showType)
      }
    }
  }
</script>

<style scoped>
  @import 'variable';

  .toggle-tab {
    z-index: 2;
    position: relative;
    display: flex;
    height: 44px;
    line-height: 44px;
    @apply --widthcenter;
    margin-bottom: 15px;
    .tab-item {
      flex: 1;
      text-align: center;
      -webkit-tap-highlight-color: transparent;
      &:first-child span {
        margin-left: 30px;
        &:before, &:after {
          left: -35px;
        }
      }
      &:last-child span {
        margin-right: 30px;
        &:before, &:after {
          right: -35px;
        }
      };
    }
    .tab-link {
      z-index: 2;
      position: relative;
      padding-bottom: 5px;
      width: 67%;
      padding: 6px 18px;
      font-size: 16px;
      border-radius: 10em;
      border: 1px solid var(--nine-color);
      &:before, &:after {
        content: '';
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
      }
      &:before {
        width: 5px;
        height: 5px;
        border-radius: 10em;
        background-color: var(--nine-color);
      }
      &:after {
        width: 35px;
        height: 0;
        border-bottom: 1px solid var(--nine-color);
      }
    }
  }
</style>